import { FC, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { DataTable } from "src/features/reporting/components";
import { useRegionReport } from "src/features/reporting/hooks";

interface Props {
	formId: number;
	year: number;
	observationType: IObservationType;
	showCompliantReport?: boolean;
	showObservationsPassedThresholdReport?: boolean;
	calendarMonth?: Month;
	calendarYear?: number;
	onDownloadReady?: (downloadFn: () => void) => void;
}

const MonthlyRegionReport: FC<Props> = ({
	formId,
	observationType,
	year,
	showCompliantReport,
	showObservationsPassedThresholdReport,
	calendarMonth,
	calendarYear,
	onDownloadReady
}) => {
	const { setValue } = useFormContext<ReportDetailForm>();

	const { columns, data, isSuccess, isLoading, download } = useRegionReport({
		formId,
		year,
		observationType,
		compliancy: showCompliantReport,
		threshold: showObservationsPassedThresholdReport
	});

	useEffect(() => {
		if (download && onDownloadReady) {
			onDownloadReady(download);
		}
	}, [download, onDownloadReady]);

	return (
		<>
			{isLoading && (
				<div className="flex justify-center items-center py-12">
					<div className="w-5 h-5 border-2 border-border border-t-primary rounded-full animate-spin" />
				</div>
			)}
			{isSuccess && (
				<DataTable
					columns={columns}
					data={data}
					calendarMonth={calendarMonth}
					calendarYear={calendarYear}
					observationType={observationType}
					emptyDataMessage="No region data found"
					onRowClick={(row: any) => setValue("filters.regionId", row.regionId)}
				/>
			)}
		</>
	);
};

export default MonthlyRegionReport;
